<template>
  <div class="errPage-container">
    <el-result title="401" subTitle="您没有权限访问！">
      <template slot="icon">
        <img src="~@/assets/errors/416.png" width="200" height="200" />
      </template>
      <template slot="extra">
        <!-- <div style="margin-bottom: 20px">{{ count }} 秒后返回首页</div> -->
        <el-button type="primary" size="small" @click="back"> 返回工作台 </el-button>
      </template>
    </el-result>
  </div>
</template>

<script>
export default {
  data() {
    return {
      count: 0, //倒计时
    }
  },
  created() {
    // this.clickJump()
  },
  methods: {
    // 几秒后进入跳转页面
    // clickJump() {
    //   const timejump = 10
    //   if (!this.timer) {
    //     this.count = timejump
    //     this.show = false
    //     this.timer = setInterval(() => {
    //       if (this.count > 0 && this.count <= timejump) {
    //         this.count--
    //       } else {
    //         this.show = true
    //         clearInterval(this.timer)
    //         this.timer = null
    //         //跳转的页面写在此处
    //         this.$router.push({ path: '/' })
    //       }
    //     }, 1000)
    //   }
    // },
    back() {
      // clearInterval(this.timer)
this.$router.push({ path: '/' })
    },
  },
}
</script>

<style lang="scss" scoped>
// .errPage-container {
//   padding-top: 100px 0;
// }
</style>
